import axios from 'axios';

export default {
	async getOrders(params){
		return axios.get('/api/v1/orders/get-orders', {params: params});
	},
	async methodPayment(params){
		return axios.post('/api/v1/orders/method-payment', params);
	},
}